const Spinner = ({ variant = 'default', size, color, borderWidth }) => {
  if (variant === 'gradient') {
    return (
      <svg viewBox="0 0 100 100" className={'comp-spinner-gradient'}>
        <foreignObject className="logoBack" x="0" y="0" width="100" height="100">
          <div className="logoGradient" xmlns="http://www.w3.org/1999/xhtml" />
        </foreignObject>
        <g className="logoBlend">
          <rect x="0" y="0" width="100" height="100" />
          <path d="M 50 96 a 46 46 0 0 1 0 -92 46 46 0 0 1 0 92" />
        </g>
      </svg>
    );
  }

  return <div className={`comp-spinner ${variant}`} style={{ width: size, height: size, fontSize: size, borderTopColor: color, borderLeftColor: color, borderWidth }} />;
};

export default Spinner;
